import { BaseAPI, Configuration } from '@rbx/clients';
import unifiedLoggerClient from '@modules/eventStream/unifiedLoggerClient';
import { getBEDEV2ServiceBasePath } from './utils';

// ! NOTE(@zwang, 01/28/25): this is a VERY special case where a client cannot be accurately
// ! generated by its swagger schema, DO NOT copy this pattern unless you know what you are doing
class GUACClient extends BaseAPI {
  constructor(basePath: string = getBEDEV2ServiceBasePath('guac-v2')) {
    const configuration = new Configuration({
      robloxSiteDomain: process.env.robloxSiteDomain,
      basePath,
      credentials: 'include',
      unifiedLogger: unifiedLoggerClient,
    });

    super(configuration);
  }

  async loadBehavior<T>(behavior: string): Promise<T> {
    return this.request({
      path: `/v1/bundles/${behavior}`,
      method: 'GET',
      headers: {},
    }).then((response) => response.json() as Promise<T>);
  }
}

const guacClient = new GUACClient();

export default guacClient;
